export type ScopePluralKind = 'section' | 'subsection';

/**
 * Polish noun form for counts of sections (dział) or subsections (poddział).
 * Uses the last decimal digit only (see tests for resulting behavior).
 */
export const resolvePluralLabel = (value: number, label: ScopePluralKind): string => {
  if (value === 1) {
    return label === 'section' ? 'dział' : 'poddział';
  }
  const lastDigit = +value.toString().charAt(value.toString().length - 1);
  if (lastDigit > 1 && lastDigit < 5) {
    return label === 'section' ? 'działy' : 'poddziały';
  }

  return label === 'section' ? 'działów' : 'poddziałów';
};
